import React from 'react';

const AboutModal = ({ isOpen, onClose }) => {
    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal show" onClick={handleOverlayClick}>
            <div className="modal-content">
                <button className="close-button" onClick={onClose}>
                    &times;
                </button>
                <h2 className="about-title" style={{ color: '#fff' }}>About</h2>
                <div className="about-text">
                    <ul>
                        <li>OSIRIS is a tool for analyzing the cyber threat intelligence data of an organization.</li>
                        <li>The stats shown on the dashboard are based on malware information stealer attacks. All records are from information stealer sources, and other records from other sources can be found in the domain/url specific pages.</li>
                        <li>The Risk Score is a heuristic calculated based on the accesses and privileges associated with the leaked credentials.</li>
                        <li>The computer type is determined based on a heuristic that, 
                            from the files extracted by the malware, calculates a score of probability of the computer being a corporate (if the use of corporate resources and software is detected), 
                            personal computer (if the use of entertainment platforms and other things that companies should not allow is detected)
                            or from an attacker (if the use of hacking tools and other indicators of an attacker are detected).
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default AboutModal;